import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { RegistrationFormStateService } from '../common';
import { PromoCodeService } from './promo-code.service';

@Component({
  selector: 'promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss'],
  host: { class: 'registration-form-section-promo-code' },
  viewProviders: [ PromoCodeService ],
  encapsulation: ViewEncapsulation.None
})
export class PromoCodeComponent implements OnInit {

  constructor(
    public stateService: RegistrationFormStateService,
    private service: PromoCodeService
  ) { }

  ngOnInit(): void {
    this.service.subscribeToAuthAndApplyPromoCode();
  }

}
